<template>
	<div class="flex flex-col">
		<div class="flex items-center gap-2">
			<span class="text-[20px] leading-[24px] text-won-dark-blue">
				{{ resumeTitle }}
			</span>
            
			<TargetIcon />
		</div>
        
        
		<span class="mt-0.5 text-[10px] leading-[12px] text-won-dark">
			Resume Builder
		</span>
	</div>
</template>

<script setup>
import TargetIcon from '../../icons/target-icon.vue';

defineProps({
	resumeTitle: {
		type: String,
		default: 'Resume Title'
	}
});
</script>
